var _title, _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#576c77",
    d: "M532.48 84.48c154.112 33.28 282.112 154.624 324.608 307.2 6.656 25.088 13.824 56.832 15.872 70.144l3.072 24.064 142.848 3.072-109.568 144.896c-60.416 79.872-110.592 146.432-112.128 147.456-2.048 2.56-223.744-287.232-223.744-292.352 0-1.536 32.256-2.56 71.68-2.56 49.152 0 71.68-2.048 71.68-5.632 0-16.384-18.432-72.192-32.256-99.328-20.48-39.424-74.24-93.184-113.664-113.664-104.96-54.784-227.328-38.912-312.832 40.96-62.976 58.368-90.624 121.856-90.624 205.824 0 78.336 22.528 135.168 75.264 191.488 49.152 52.224 107.52 79.872 182.784 87.040 52.224 4.608 72.192 15.872 87.040 48.64 12.288 27.136 12.288 40.96-0.512 66.56-15.872 32.256-31.744 40.96-77.312 43.008-153.6 7.168-318.464-101.376-389.12-257.536-48.128-105.984-48.128-252.416 0-358.4 57.856-127.488 175.104-223.232 307.712-250.88 45.056-9.216 134.144-9.216 179.2 0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.20502e96.svg";
export { ForwardRef as ReactComponent };